
(function() {
  var result = { translations: { "bn": { "i18n": { "duration": { "seconds": "{{ seconds }}\u09B8\u09C7\u0995", "minutes": "{{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "hours": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE", "hoursAndMinutes": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE {{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "days": "{{ days }}\u09A6\u09BF\u09A8\xA0", "shortForm": { "seconds": "{{ seconds }}\u09B8\u09C7", "minutes": "{{ minutes }}\u09AE\u09BF\xA0", "hours": "{{ hours }}\u0998", "days": "{{ days }}\u09A6\u09BF\xA0", "hoursAndMinutes": "{{ hours }}\u0998 {{ minutes }}\u09AE\u09BF" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}},\u098F\u0995\u09CD\u09B8\u099F.{{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "bn": "static-7.932"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.932",
    "ar-eg": "static-7.932",
    "bg": "static-7.932",
    "bn": "static-7.932",
    "ca-es": "static-7.932",
    "cs": "static-7.932",
    "da": "static-7.932",
    "de": "static-7.932",
    "el": "static-7.932",
    "en-gb": "static-7.932",
    "en": "static-7.932",
    "es-mx": "static-7.932",
    "es": "static-7.932",
    "fi": "static-7.932",
    "fr-ca": "static-7.932",
    "fr": "static-7.932",
    "he-il": "static-7.932",
    "hr": "static-7.932",
    "hu": "static-7.932",
    "id": "static-7.932",
    "it": "static-7.932",
    "ja": "static-7.932",
    "ko": "static-7.932",
    "lt": "static-7.932",
    "ms": "static-7.932",
    "nl": "static-7.932",
    "no": "static-7.932",
    "pl": "static-7.932",
    "pt-br": "static-7.932",
    "pt-pt": "static-7.932",
    "ro": "static-7.932",
    "ru": "static-7.932",
    "sk": "static-7.932",
    "sl": "static-7.932",
    "sv": "static-7.932",
    "th": "static-7.932",
    "tl": "static-7.932",
    "tr": "static-7.932",
    "uk": "static-7.932",
    "vi": "static-7.932",
    "x-pseudo": "static-7.932",
    "zh-cn": "static-7.932",
    "zh-hk": "static-7.932",
    "zh-tw": "static-7.932"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bn', {version: 'static-7.932'}); }
})();


